/**
 * Copied from portalExtensions.js since pages using this file are lightweight
 * and don't need all the dependencies of portalExtensions.js
 */
(function() {
   var m_bLoaded = false;
   var m_bLoading = false;
   var m_fnComplete = [];

   window.globalMappingBingMapsReady = function () {
      m_bLoaded = true;
      $.each(m_fnComplete, function (i, fn) {
         fn();
      });
   };

   window.loadBingMaps = function (fnComplete) {
      // Only continue if this is NOT the liquidMapping page...
      if ($("#mappingHeader").length == 1) return;

      if (m_bLoaded || (window.Microsoft && window.Microsoft.Maps)) {
         fnComplete();
         return;
      };

      m_fnComplete.push(fnComplete);

      if (m_bLoading) return;
      m_bLoading = true;

      var strUrl = '//www.bing.com/api/maps/mapcontrol?branch=experimental&callback=globalMappingBingMapsReady';
      $.ajax({
         url: strUrl,
         dataType: "script",
         success: function() {
            // Don't do anything here. Wait for callback.
         },
         cache: true
      });
   };
}());

var portalMapping = (function() {
   var m_strStartAddress, m_strEndAddress, m_propertyBrandCd;
   var m_directionsWindow, m_map;

   function showDirectionsWindow(srcAddr, destAddr, propertyBrandCd) {
      var strUrl = "/mapping/directionsPopup.html",
         oOptions = {
            startAddress: srcAddr,
            endAddress: destAddr,
            propBrandCd: propertyBrandCd
         };
      
         if( (window.websiteCode == 'ESP') || (window.location.hostname.indexOf("espanol") == 0)) {
            strUrl = "/mapping/directionsPopup_esp.html";
         }
      
         var strFullUrl = strUrl + '?' + $.param(oOptions);
      m_directionsWindow = window.open(strFullUrl, "Directions", "location=1,status=1,scrollbars=1,width=800,height=600");
      
      return false;
   }

   function showOfficeDirectionsWindow (strAddressStart, strOfficeAddress, officeLatitude, officeLongitude) {
      var strUrl = "/mapping/directionsPopupOdp.html",
         oOptions = {
            startAddress: strAddressStart,
            endAddress: strOfficeAddress,
            officeLatitude: officeLatitude,
            officeLongitude: officeLongitude
         };

         if( (window.websiteCode == 'ESP') || (window.location.hostname.indexOf("espanol") == 0)) {
            strUrl = "/mapping/directionsPopupOdp_esp.html";
         }
      
         var strFullUrl = strUrl + '?' + $.param(oOptions);

      m_directionsWindow = window.open(strFullUrl, "Directions", "location=1,status=1,scrollbars=1,width=800,height=600");

      return false;
   }

   /**
    * Initialize Bing maps
    */
   function createMap() {
      m_map = new Microsoft.Maps.Map(document.getElementById('map'), {
         credentials: "AqK6Xm4vKQ14R0qING7QBL3FFqQDNoHrM0xVWiVT9yyukhvj7q6TBcylAn6DbA0o",
      });
   }

   var m_directionsManager;
   function getRoute(strAddressFrom, strAddressTo) {
      function showDirections() {
         // Set Route Mode to driving
         m_directionsManager.setRequestOptions({ routeMode: Microsoft.Maps.Directions.RouteMode.driving });
         var waypoint1 = new Microsoft.Maps.Directions.Waypoint({ address: strAddressFrom });
         var waypoint2 = new Microsoft.Maps.Directions.Waypoint({ address: strAddressTo });
         m_directionsManager.addWaypoint(waypoint1);
         m_directionsManager.addWaypoint(waypoint2);

         // Set the element in which the itinerary will be rendered
         m_directionsManager.setRenderOptions({ itineraryContainer: document.getElementById('directions') });
         m_directionsManager.calculateDirections();
      }

      if (!m_directionsManager) {
         Microsoft.Maps.loadModule('Microsoft.Maps.Directions', function () {
            m_directionsManager = new Microsoft.Maps.Directions.DirectionsManager(m_map);
            showDirections();
         });
      } else {
         m_directionsManager.clearAll();
         showDirections();
      }

      $('#startAddress').text(strAddressFrom);
      $('#endAddress').text(strAddressTo);
      $('#propertyBrandCd').val(m_propertyBrandCd);
   }

   function getAddresses() {
      var oParams = portalAjax.getParameters();
      m_strStartAddress = oParams.startAddress;
      m_strEndAddress = oParams.endAddress;
      m_propertyBrandCd = oParams.propBrandCd;
   }

   function getRouteFromProperty() {
      getRoute(m_strEndAddress, m_strStartAddress);
   }

   function getRouteToProperty() {
      getRoute(m_strStartAddress, m_strEndAddress);
   }

   function reverseDirections() {
      var strTemp = m_strStartAddress;
      m_strStartAddress = m_strEndAddress;
      m_strEndAddress = strTemp;
   }

   function initializeDirections() {
      getAddresses();
      loadBingMaps(function() {
         createMap();
         getRouteToProperty();

         var bDirectionsReversed = false;
         $('#reverseDirections').click(function() {
            if (bDirectionsReversed) {
               bDirectionsReversed = false;
               getRouteToProperty();
            } else {
               bDirectionsReversed = true;
               getRouteFromProperty();
            }

            return false;
         });

         $('#print').click(function() {
            window.print();
            return false;
         });
      });
   }

   return {
      showDirectionsWindow : showDirectionsWindow,
      showOfficeDirectionsWindow: showOfficeDirectionsWindow,
      initializeDirections: initializeDirections
   };
})();
